<template>
  <div class="hello">
    <v-layout align-center justify-center row fill-height>
      <!-- <v-flex xs4 md5>       
          <img src="../assets/HealthLogo.png"/>        
      </v-flex>-->
      <v-flex xs9>
        <h1 class="display-1 mt-4 primary--text">
          Welcome To The Wyoming State Loan Repayment Program Application
        </h1>
        <div class="mt-2 text-headline headline"
          >Accepting Applications through September 9, 2024</div
        >
        <v-card class="mt-3">
          <v-list>
            <v-list-tile
              href="./files/Summer 2024 WY-SLRP Application Package.pdf"
              target="_blank"
            >
              <v-list-item-title>
                Summer 2024 Application Guidance
              </v-list-item-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile
              href="./files/Wyoming State Loan Repayment Program Application and Award Monitoring System Instructions.pdf"
              target="_blank"
            >
              <v-list-item-title>
                Application System Instructions
              </v-list-item-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile
              href="./files/2024 WY-SLRP Eligible Sites.pdf"
              target="_blank"
            >
              <v-list-item-title>
                2024 WY-SLRP Eligible Sites
              </v-list-item-title>
            </v-list-tile>
          </v-list>
        </v-card>
        <!-- <p class="text-sm-left mt-4"
          >The Wyoming State Loan Repayment Program (WY-SLRP) is open to
          physicians, nurse practitioners, physician assistants, certified nurse
          midwives, and mental health clinicians practicing in primary care and
          mental health settings. Applicants must practice full-time at an
          already approved National Health Service Corps site.</p
        >
        <ul class="text-sm-left">
          <li
            >Physicians are eligible for up to $40,000 in loan repayment in
            exchange for two (2) years of full-time practice at the approved
            National Health Service Corps site.</li
          >
          <li
            >Nurse practitioners, physician assistants, certified nurse
            midwives, and mental health clinicians are eligible for up to
            $20,000 in loan repayment in exchange for two (2) years of full-time
            practice at the approved National Health Service Corps site.</li
          >
        </ul>
        <p class="text-sm-left mt-4"
        >The Wyoming Department of Health, Public Health Division, Office of
        Rural Health (ORH) receives funding from the U.S. Department of Health
        and Human Services, Health Resources and Services Administration,
          Bureau of Health Workforce, Division of National Health Service Corps
          to fund the Wyoming State Loan Repayment Program (WY-SLRP). The
          WY-SLRP is funded in combination by the State Loan Repayment Program
          Grant, Catalog of Federal Domestic Assistance (CFDA) number 93.165
          (50%) and State of Wyoming general funds assigned to the Office of
          Rural Health (50%). </p
        ><p class="text-sm-left mt-4"
          >The purpose of WY-SLRP is to increase the recruitment and retention
          of primary care and mental health providers in federally designated
          Health Professional Shortage Areas (HPSAs).</p
          > -->
        <p class="text-sm-left mt-4">
          The purpose of the Wyoming State Loan Repayment Program (WY-SLRP) is
          to increase the recruitment and retention of primary care, dental
          care, and mental health providers in federally designated Health
          Professional Shortage Areas (HPSAs).
        </p>
        <p class="text-sm-left mt-4">
          The Wyoming Department of Health, Public Health Division, Office of
          Rural Health (ORH) receives funding from the U.S. Department of Health
          and Human Services, Health Resources and Services Administration,
          Bureau of Health Workforce, Division of National Health Service Corps
          to fund WY-SLRP. The WY-SLRP is funded by the Grants to States for
          Loan Repayment Program, Catalog of Federal Domestic Assistance (CFDA)
          number 93.165 (100%).
        </p>
        <p class="text-sm-left mt-4">
          WY-SLRP is open to physicians, dentists, nurse practitioners,
          physician assistants, certified nurse midwives, pharmacists,
          registered nurses, registered dental hygienists, and mental health
          clinicians practicing in primary care, dental care, and mental health
          settings. Applicants must practice full-time at an already approved
          National Health Service Corps (NHSC) site.
        </p>
        <p class="text-sm-left mt-4">
          Selected applicants will be eligible for up to $50,000 in loan
          repayment in exchange for two (2) years of full-time practice at the
          approved NHSC site.
        </p>
        <!-- <p class="text-sm-left mt-4">Applications will be accepted through 5 PM on October 31, 2017</p> -->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }
// .logo {
//   align-content: right;
// }
h1,
h3,
h2 {
  color: #616161;
}
p,
ul {
  color: #757575;
}
</style>
